
















































































































































































import { Component, Vue } from 'vue-property-decorator';

interface ExpiredLicenseRecord {
  [key: string]: any;
}

interface LicenseTableRow {
  row_id: string;
  user_id?: number | string;
  user_name: string;
  email: string;
  phone: string;
  tenant_name: string;
  start_date: string | null;
  end_date: string | null;
  expires_at: string | null;
  days: number | string;
  mevcut_programlar: any[];
  gecmis_programlar: any[];
  source: ExpiredLicenseRecord;
}

const LICENSE_TABLE_HEADERS = [
  { text: 'Kullanıcı', value: 'user_name' },
  { text: 'E-Posta', value: 'email' },
  { text: 'Mevcut Programlar', value: 'mevcut_programlar' },
  { text: 'Geçmiş Programlar', value: 'gecmis_programlar' },
];

@Component
export default class Musteri extends Vue {
  expiredLicenses: ExpiredLicenseRecord[] = [];
  selectedLicenses: LicenseTableRow[] = [];
  licenseHeaders = [...LICENSE_TABLE_HEADERS];
  licenseSearch = '';
  isLicenseLoading = false;
  licenseError: string | null = null;
  days = 30;
  page = 1;
  perPage = 50;
  lastUpdated: Date | null = null;

  emailSubject = 'Lisans Süreniz Doldu';
  emailBody = `Merhaba {{name}},\n\nLisansınız {{expires_at}} tarihinde sona ermiştir.\nHemen giriş yaparak lisansınızı yenileyebilirsiniz.\n\nİyi çalışmalar.`;
  mailSending = false;
  mailTarget: 'selected' | 'all' | null = null;
  mailSuccess: string | null = null;
  mailError: string | null = null;

  mounted(): void {
    this.refreshLicenses();
  }

  get selectedCount(): number {
    return this.selectedLicenses.length;
  }

  get hasSelection(): boolean {
    return this.selectedCount > 0;
  }

  get lastUpdatedText(): string {
    if (!this.lastUpdated) {
      return '';
    }
    return new Intl.DateTimeFormat('tr-TR', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }).format(this.lastUpdated);
  }

  get licensesEndpoint(): string {
    const baseUrl = this.$store?.state?.icwApiUrl || '';
    return `${baseUrl}admin/licenses/expired`;
  }

  get sendMailEndpoint(): string {
    return `/sendmail`;
  }

  get tableRows(): LicenseTableRow[] {
    return this.expiredLicenses.map((license, index) => this.transformLicense(license, index));
  }

  handleDaysChange(): void {
    if (!this.days || this.days < 1) {
      this.days = 1;
    }
    this.page = 1;
  }

  async refreshLicenses(): Promise<void> {
    this.handleDaysChange();
    await this.fetchExpiredLicenses();
  }

  async fetchExpiredLicenses(): Promise<void> {
    this.isLicenseLoading = true;
    this.licenseError = null;
    try {
      const response = await this.$http.get(this.licensesEndpoint, {
        params: {
          days: this.days,
          page: this.page,
          per_page: this.perPage,
        },
      });
      const payload = Array.isArray(response.data)
        ? response.data
        : Array.isArray(response.data?.data)
        ? response.data.data
        : [];
      this.expiredLicenses = payload;
      this.selectedLicenses = [];
      this.lastUpdated = new Date();
    } catch (error) {
      console.error('Lisans bilgileri alınırken hata oluştu:', error);
      this.licenseError = 'Lisans verileri alınamadı. Lütfen daha sonra tekrar deneyin.';
      this.$toast?.error('Lisans verileri alınamadı.');
    } finally {
      this.isLicenseLoading = false;
    }
  }

  async sendMail(target: 'selected' | 'all'): Promise<void> {
    if (target === 'selected' && !this.hasSelection) {
      this.$toast?.info('Gönderim yapmak için en az bir kullanıcı seçmelisiniz.');
      return;
    }

    const targetRows = target === 'selected' ? this.selectedLicenses : this.tableRows;
    const recipients = targetRows
      .map((license) => {
        const sourceUser = license.source?.user || {};
        const surname = sourceUser.surname ?? sourceUser.last_name ?? '';
        const fullName = surname
          ? `${license.user_name} ${surname}`
          : license.user_name;

        return {
          name: fullName,
          email: license.email,
          expires_at: license.expires_at,
        };
      })
      .filter((recipient) => recipient.email && recipient.email !== '-');

    if (!recipients.length) {
      this.$toast?.info('Geçerli e-posta adresi olan kullanıcı bulunamadı.');
      return;
    }

    this.mailSending = true;
    this.mailTarget = target;
    this.mailSuccess = null;
    this.mailError = null;

    const payload = {
      body: this.emailBody,
      subject: this.emailSubject,
      data: JSON.stringify(recipients),
    };

    try {
      await this.$http.post(this.sendMailEndpoint, payload);
      const recipientCount = recipients.length;
      this.mailSuccess =
        target === 'all'
          ? `${recipientCount} kullanıcı için mail gönderimi başlatıldı.`
          : `${recipientCount} kullanıcıya mail gönderildi.`;
      this.$toast?.success(this.mailSuccess);
    } catch (error) {
      console.error('Mail gönderimi sırasında hata oluştu:', error);
      this.mailError = 'Mail gönderimi başarısız oldu. Lütfen tekrar deneyiniz.';
      this.$toast?.error(this.mailError);
    } finally {
      this.mailSending = false;
      this.mailTarget = null;
    }
  }

  transformLicense(license: ExpiredLicenseRecord, index: number): LicenseTableRow {
    const user = license.user || license.kullanici || license.customer || {};
    const tenant = license.tenant || license.buro || license.office || {};
    const firstName = user.name ?? user.first_name ?? license.name ?? '';
    const lastName = user.lastname ?? user.last_name ?? license.lastname ?? '';
    const fullName = [firstName, lastName].filter(Boolean).join(' ')
      || user.full_name
      || license.user_name
      || license.full_name
      || '-';

    const email = user.email ?? license.email ?? '-';
    const phone = user.phone ?? user.phone_number ?? license.phone ?? license.phone_number ?? '-';
    const tenantName = tenant.name
      ?? tenant.buro_adi
      ?? tenant.office_name
      ?? license.buro_name
      ?? license.tenant_name
      ?? '-';

    const startDateRaw = license.start_date ?? license.license_start ?? license.begin_date ?? null;
    const endDateRaw = license.end_date ?? license.license_end ?? license.license_end_date ?? null;
    const startDate = this.stripTime(startDateRaw);
    const endDate = this.stripTime(endDateRaw);
    // Eğer gecmis_programlar varsa, bitiş tarihini oradan al
    let expiresAtRaw = null;
    if (Array.isArray(license.gecmis_programlar) && license.gecmis_programlar.length > 0) {
      // Son programın end_date değerini kullan
      const lastProgram = license.gecmis_programlar[license.gecmis_programlar.length - 1];
      expiresAtRaw = lastProgram.end_date ?? null;
    }

    const expiresAt = this.stripTime(
      expiresAtRaw ??
      endDateRaw ??
      license.expires_at ??
      license.license_end ??
      license.license_end_date ??
      null
    );
    const days = license.days ?? license.expire_days ?? license.expire_day ?? license.kalan_gun ?? '-';
    const rowId = `${user.id ?? license.user_id ?? license.id ?? 'row'}-${index}`;

    return {
      row_id: rowId,
      user_id: user.id ?? license.user_id ?? license.id,
      user_name: fullName,
      email,
      phone,
      tenant_name: tenantName,
      start_date: startDate,
      end_date: endDate,
      expires_at: expiresAt,
      days,
      mevcut_programlar: this.normalizePrograms(
        license.mevcut_programlar ?? license.programlar?.aktif ?? license.programlar ?? []
      ),
      gecmis_programlar: this.normalizePrograms(
        license.gecmis_programlar ?? license.programlar?.gecmis ?? []
      ),
      source: license,
    };
  }

  normalizePrograms(programs: any): any[] {
    if (!programs) {
      return [];
    }
    if (Array.isArray(programs)) {
      return programs.filter((program) => program !== null && program !== undefined);
    }
    if (typeof programs === 'string') {
      return programs
        .split(',')
        .map((program) => program.trim())
        .filter((program) => program.length > 0);
    }
    if (typeof programs === 'object') {
      return Object.values(programs);
    }
    return [programs];
  }

  stripTime(value: any): string | null {
    if (!value) {
      return null;
    }
    if (typeof value === 'string') {
      const isoMatch = value.match(/^(\d{4}-\d{2}-\d{2})/);
      if (isoMatch) {
        return isoMatch[1];
      }
      const spaceSplit = value.split(' ');
      if (spaceSplit.length > 0 && /\d{4}-\d{2}-\d{2}/.test(spaceSplit[0])) {
        return spaceSplit[0];
      }
    }
    const date = new Date(value);
    if (!Number.isNaN(date.getTime())) {
      return date.toISOString().split('T')[0];
    }
    return typeof value === 'string' ? value : null;
  }

  formatDate(value: any): string {
    if (!value) {
      return '-';
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return value;
    }
    return new Intl.DateTimeFormat('tr-TR', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }).format(date);
  }

  get footerProps() {
    return {
      'items-per-page-options': [15, 30, 50, 100],
      showFirstLastPage: true,
    };
  }

  onPageChange(newPage: number): void {
    if (this.page === newPage) {
      return;
    }
    this.page = newPage;
    this.fetchExpiredLicenses();
  }

  onItemsPerPageChange(newItemsPerPage: number): void {
    if (this.perPage === newItemsPerPage) {
      return;
    }
    this.perPage = newItemsPerPage;
    this.page = 1;
    this.fetchExpiredLicenses();
  }
}
